<!--
 * @Author: lishiqiao
 * @Date: 2022-03-01 10:32:33
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 16:12:39
-->
<template>
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">动保使用记录</div>
      </div>
      <div class="page-list">
        <!-- 搜索栏 -->
        <div class="page-search-content" ref="searchBox">
          <div class="page-big-box">
            <div class="page-search-item">
              <label>养殖场&nbsp;:</label>
              <el-select v-model="params.params.baseId" @change="selectBase" filterable placeholder="请选择养殖场">
                <el-option label="全部养殖场" value=""></el-option>
                <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖分组&nbsp;:</label>
              <el-select v-model="params.params.groupId" @change="selectGroup" filterable placeholder="请选择分组">
                <el-option label="全部分组" value=""></el-option>
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖单元&nbsp;:</label>
              <el-select v-model="params.params.boxId" filterable placeholder="请选择单元">
                <el-option label="全部单元" value=""></el-option>
                <el-option v-for="item in boxList" :key="item.id" :label="item.boxCode" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>动保名称&nbsp;:</label>
              <el-select v-model="drugId" @change="selectDrug" filterable placeholder="请选择动保">
                <el-option label="全部动保" value=""></el-option>
                <el-option v-for="(item, idx) of drugList" :key="item.drugId + idx" :label="item.drugName"
                  :value="item.drugId">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>使用时间&nbsp;:</label>
              <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" @change="dateChange"
                :picker-options="pickerOptions" type="daterange" range-separator="~" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="page-search-item">
              <label>动保类型 &nbsp;:</label>
              <el-select v-model="params.params.drugType" filterable placeholder="请选择类型">
                <el-option label="全部类型" value=""></el-option>
                <el-option v-for="item in drugTypeList" :key="item.id" :label="item.typeName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>记录状态 &nbsp;:</label>
              <el-select v-model="params.params.status" filterable placeholder="请选择状态">
                <el-option label="全部状态" value=""></el-option>
                <el-option v-for="item in reviewStatusList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>汇总类型 &nbsp;:</label>
              <el-select v-model="params.params.groupType" filterable placeholder="请选择类型">
                <el-option label="全部类型" value=""></el-option>
                <el-option v-for="item in groupTypeList" :key="item.typeId" :label="item.typeName" :value="item.typeId">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="page-search-btn">
            <div class="search-btn" @click="search">查询</div>
            <div class="reset-btn" @click="reset">重置</div>
            <div class="search-close-btn">
              <div @click="PageSearchClose" v-if="PageDisplay">
                <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
              </div>
              <div @click="PageSearchOn" v-else>
                <span>展开</span><i class="iconfont icon-List-Collapse"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="page-list-content">
          <el-dialog title="文件上传" width="25%" :visible.sync="dialogVisible">
            <span>
              <el-upload action="" :file-list="fileList" :show-file-list="false" :on-change="handleChange"
                :on-exceed="hanleExceed" accept=".xls, .xlsx" :limit="1" :auto-upload="false">
                <span class="file-name">{{ fileList[0].name }}</span>
                <el-button slot="trigger" size="small">浏览</el-button>
              </el-upload>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="dialogVisible = false">取 消</el-button>
              <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload"
                :disabled="!fileList[0].raw" :loading="loading">上传</el-button>
            </span>
          </el-dialog>
          <!-- 列表 -->
          <div class="page-list-title">
            <div><i class="title-icon"></i>动保使用记录</div>
            <div>单位 : {{ unitName }}</div>
            <div></div>
            <div>
              <!-- 暂时去掉按钮 -->
              <!-- <span
                class="action-button"
                @click="downloadTemp"
              >
                模板下载
              </span>
              <span
                class="action-button"
                @click="dialogVisible = true"
              >
                导入报表
              </span> -->
              <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
                <span class="el-dropdown-link">
                  冻结列<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="y">冻结至"{{
                    fixedColumn.label
                  }}"列</el-dropdown-item>
                  <el-dropdown-item command="n">取消冻结</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="action-button" @click="exportTable">
                <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
              </span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%"
            :row-class-name="tableRowClassName" @header-click="handleClick">
            <el-table-column :fixed="fixedColumnList[0].fixed"
              :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''" prop="groupName" label="区域分组">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[1].fixed"
              :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''" prop="boxCode" label="养殖单元">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[2].fixed"
              :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''" prop="useMedicineReason" label="动保原因">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[3].fixed"
              :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''" prop="useMedicineTime" label="使用时间">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[4].fixed"
              :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''" prop="drugTypeName" label="动保类型">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[5].fixed"
              :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''" prop="drugName" label="动保名称">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[6].fixed"
              :class-name="fixedColumnList[6].selected ? 'cellSelected' : ''" prop="specification" label="规格">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[7].fixed"
              :class-name="fixedColumnList[7].selected ? 'cellSelected' : ''" prop="unitName" label="计量单位">
            </el-table-column>
            <el-table-column prop="amount" label="动保量"> </el-table-column>
            <el-table-column prop="putMoney" label="使用金额">
            </el-table-column>
            <el-table-column prop="concentrationAndUnitName" label="动保浓度">
            </el-table-column>
            <el-table-column prop="useWayName" label="使用方式">
            </el-table-column>
            <el-table-column prop="drugPeople" label="施药人">
            </el-table-column>
            <el-table-column prop="recipeName" label="处方名">
            </el-table-column>
            <el-table-column prop="recipePeople" label="处方人">
            </el-table-column>
            <el-table-column prop="statusName" label="记录状态">
            </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="uyu-pagination">
            <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
              :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="params.currPage" :pageSize.sync="params.pageSize"
              :totalCount="totalCount">
            </MyPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyPagination from "@/components/pc/my-pagination.vue";
import service from "./ym-drug-service";
import Page from "@/utils/methods/page";
export default {
  name: "drug-use",
  data() {
    return {
      unitName: "", // 单位名称
      dateRange: [
        this.$moment().format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ],
      PageDisplay: true,
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxCode",
          fixed: false,
          selected: false
        },
        {
          prop: "useMedicineReason",
          fixed: false,
          selected: false
        },
        {
          prop: "useMedicineTime",
          fixed: false,
          selected: false
        },
        {
          prop: "drugTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "drugName",
          fixed: false,
          selected: false
        },
        {
          prop: "specification",
          fixed: false,
          selected: false
        },
        {
          prop: "unitName",
          fixed: false,
          selected: false
        },
      ],
      params: {
        currPage: 1, // 当前页
        pageSize: 13, // 每页条数
        orderBy: "desc",
        orderByName: "useMedicineTime",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          boxId: "",
          drugType: "",
          startDate: this.$moment().format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
          drugName: "",
          status: "",
          groupType: "",
        },
      },
      drugId: "",
      totalCount: 0, // 总条数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      dialogVisible: false,
      fileList: [{ name: "请选择文件" }], // 上传文件列表
      loading: false,
      baseList: [], // 基地列表
      groupList: [], // 分组列表
      boxList: [], // 单元列表
      drugList: [], // 动保名称
      drugTypeList: [], // 动保类型
      // 记录状态
      reviewStatusList: [
        {
          id: 0,
          name: "草稿",
        },
        {
          id: 1,
          name: "待审核",
        },
        {
          id: 2,
          name: "已审核",
        },
      ],
      groupTypeList: [], // 汇总类型
      exportParams: {}, // 导出参数
      tableData: [],
    };
  },
  components: { MyPagination },
  created() {
    this.tableHeight = window.innerHeight - 450;
    this.params.params.orgId = localStorage.getItem("rootId");
    this.unitName = localStorage.getItem("orgName");
    this.getBaseListsByUser(); // 获取基地列表
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 09:44:06
     * @description: 获取用户权限基地
     * @param {*}
     */
    getBaseListsByUser() {
      service
        .getBaseListsByUser()
        .then((res) => {
          if (res.code == "0000") {
            this.baseList = res.data;
            if (this.baseList && this.baseList.length) {
              this.params.params.orgId = this.baseList[0].orgId;
              this.params.params.baseId = this.baseList[0].id;
              this.getPageList(); // 获取分页
              this.queryBaseGroupList(this.params.params.baseId); // 获取区域分组
              this.getMedicinalsList(this.params.params.baseId); // 获取动保名称
              this.getDrugTypeList(this.params.params.orgId); // 获取动保类型
              this.getTotalType(); // 获取汇总类型
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:03:48
     * @description: 选择基地
     * @param {*}
     */
    selectBase(event) {
      this.params.params.orgId = "";
      this.params.params.boxId = "";
      this.boxList = [];
      this.params.params.groupId = "";
      this.groupList = [];
      this.drugId = "";
      this.drugList = [];
      this.params.params.drugType = "";
      this.drugTypeList = [];
      if (!event) {
        return;
      }
      this.params.params.orgId = this.baseList.filter(
        (item) => item.id === event
      )[0].orgId;
      this.queryBaseGroupList(event); // 根据基地id获取区域分组
      this.getMedicinalsList(event); // 获取动保名称
      this.getDrugTypeList(this.params.params.orgId); // 根据机构id获取动保类型
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:12:42
     * @description: 获取区域分组
     * @param {*} baseId
     */
    queryBaseGroupList(baseId) {
      service
        .queryBaseGroupList(baseId)
        .then((res) => {
          if (res.code == "0000") {
            this.groupList = res.data;
          } else {
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:16:02
     * @description: 选择区域分组
     * @param {*} event
     */
    selectGroup(event) {
      this.params.params.boxId = "";
      this.boxList = [];
      if (!event) {
        return;
      }
      this.listDataPermissionBoxData(event); // 根据区域id获取区域塘口单元
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:13:16
     * @description: 获取区域塘口单元
     * @param {*} groupId
     */
    listDataPermissionBoxData(groupId) {
      service
        .listDataPermissionBoxData(groupId)
        .then((res) => {
          if (res.code == "0000") {
            this.boxList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-07-01 15:38:15
     * @description: 根据基地id获取动保名称列表
     * @param {*} baseId
     */
    getMedicinalsList(baseId) {
      service
        .getMedicinalsList(baseId)
        .then((res) => {
          if (res.code == "0000") {
            this.drugList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-07-01 15:45:26
     * @description: 选择饲料名称
     * @param {*} event
     */
    selectDrug(event) {
      this.params.params.drugName = "";
      if (!event) {
        return;
      }
      this.params.params.drugName = this.drugList.filter(
        (item) => item.drugId === event
      )[0].drugName;
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:24:40
     * @description:获取动保类型列表
     * @param {*} orgId
     */
    getDrugTypeList(orgId) {
      service
        .getDrugTypeList(orgId)
        .then((res) => {
          if (res.code == "0000") {
            this.drugTypeList = res.data;
          } else {
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:47:36
     * @description: 获取汇总类型列表
     * @param {*}
     */
    getTotalType() {
      service
        .getTotalType()
        .then((res) => {
          if (res.code == "0000") {
            this.groupTypeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 重置
    reset() {
      this.params.params.groupId = "";
      this.params.params.boxId = "";
      this.boxList = [];
      this.drugId = "";
      this.params.params.drugName = "";
      this.dateRange = [];
      this.params.params.startDate = this.$moment().format("YYYY-MM-DD");
      this.params.params.endDate = this.$moment().format("YYYY-MM-DD");
      this.dateRange.push(this.params.params.startDate);
      this.dateRange.push(this.params.params.endDate);
      this.params.params.drugType = "";
      this.params.params.status = "";
      this.params.params.groupType = "";
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.groupName === "合计") {
        return "heji-row";
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:17:40
     * @description: 分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getDrugUsePageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.params.currPage = res.data.pageNumber;
            this.params.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
            this.tableData = res.data.list;
            this.exportParams = JSON.parse(JSON.stringify(this.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-02 17:32:36
     * @description: 模板下载
     * @param {*}
     */
    downloadTemp() {
      this.$confirm(`动保使用记录模板下载，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          const param = {
            fileName: "动保使用记录模板",
          };
          service
            .exportDrugUseData(param)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => { });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-04 14:30:59
     * @description:导入
     * @param {*} params
     */
    importExcel(params) {
      this.loading = true;
      service
        .importExcel(params)
        .then((res) => {
          if (res.code == "0000") {
            this.$message.success(res.msg);
            this.dialogVisible = false;
          } else {
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },

    // 上传
    submitUpload() {
      let fd = new FormData();
      fd.append("orgId", this.params.params.orgId);
      fd.append("isStock", false);
      fd.append("language", "zh");
      fd.append("file", this.fileList[0].raw);
      this.importExcel(fd);
    },

    // 选择文件
    handleChange(file, fileList) {
      this.fileList = fileList;
    },

    // 超过文件个数
    hanleExceed(file, fileList) {
      this.fileList[0].name = file[0].name;
      this.fileList[0].raw = file[0];
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:17:53
     * @description: 导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          const param = {
            titleName: "动保使用记录",
            sheetName: "列表",
            fileName: "动保使用记录",
            fileCode: "drugMedicationExport_zh",
            param: this.exportParams,
          };
          service
            .exporDrugUsetData(param)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => { });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-07 10:07:26
     * @description: 切换单前页
     * @param {*} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList();
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-07 10:14:06
     * @description: 改变当前分页总数
     * @param {*} event
     */
    handleSizeChange(event) {
      this.params.pageSize = event;
      this.params.currPage = 1;
      this.getPageList();
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.fileList = [{ name: "请选择文件" }];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-list-content {
  /deep/.el-dialog__wrapper {
    >div {
      margin-top: 25vh !important;

      .el-dialog__body {
        >span {
          >div {
            position: relative;

            .el-upload.el-upload--text {
              position: absolute;
              right: 0;
              top: 0;
            }

            .file-name {
              box-sizing: border-box;
              width: calc(100% - 70px);
              display: block;
              height: 32px;
              border: 1px rgb(220, 223, 230) solid;
              border-radius: 4px;
              cursor: pointer;
              padding-left: 10px;
              line-height: 30px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .el-dialog__footer {
        text-align: center;
      }
    }
  }
}
</style>